// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2798645e","933":"f1e501ca"}[chunkId] + ".chunk.js";
};